module.exports = "https://store.zigzag.kr/resources/arm64/20260228-1402-69c11d9c65_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";